import { IComponentAsset, ILibraryAsset } from '../registry.types';
import { isServer } from '../flags';
import { filterStyleAssets } from '../toolbox/assets';

function isCSSAssetLoaded(url: string) {
  return (
    // pre fetched (inlined) style tag
    document.querySelector(`style[data-href="${url}"]`) !== null ||
    // normal CSS import
    document.querySelector(`link[href="${url}"]`)
  );
}

function injectStyleTag(url: string) {
  return new Promise((resolve, reject) => {
    const style = document.createElement('link');
    style.setAttribute('rel', 'stylesheet');
    style.setAttribute('type', 'text/css');
    style.setAttribute('href', url);
    style.addEventListener('load', () => resolve(url));
    style.addEventListener('error', e => reject(e));

    document.head.appendChild(style);
  });
}

export function loadLibraryAssets(assets: Array<ILibraryAsset>) {
  loadAssets(assets);
}

export function loadAssets(assets: Array<IComponentAsset>) {
  const styleAssets = filterStyleAssets(assets) as Array<
    IComponentAsset<'style', 'css'>
  >;

  return loadCSSAssets([
    ...styleAssets.filter(asset => !!asset.dependency),
    ...styleAssets.filter(asset => !asset.dependency),
  ]);
}

export function loadCSSAssets(assets: Array<IComponentAsset<'style', 'css'>>) {
  if (isServer) {
    return Promise.resolve();
  }

  return Promise.all(
    assets
      .filter(({ url }) => !isCSSAssetLoaded(url))
      .map(({ url }) => injectStyleTag(url)),
  );
}
